import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-box-placeloader',
  templateUrl: 'box-placeloader.component.html',
  styleUrls: ['box-placeloader.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.stacked]': 'stacked',
  },
})
export class BoxPlaceloaderComponent {
  @Input() public onlyOnePlaceloader: boolean = false;
  @Input() public height: number = 0;
  @Input() public stacked: boolean;
}
